// @mui material components
import { Snackbar, Alert, Grid, Card, CircularProgress, Backdrop, Icon } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
// import MDInput from "theme/components/MDInput";
import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
// import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";
// import { useAuthUser } from "react-auth-kit";
// import AppConfig from "appConfig";

// import Editor from "react-simple-wysiwyg";
import GoogleMapReact from "google-map-react";
import AppConfig from "appConfig";

function DashboardOverview() {
  const pageTitle = "Account Sales";
  usePageTitle(pageTitle);

  // const auth = useAuthUser();
  // const accountInfo = auth();

  // const { id } = useParams();

  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  // const [openNewCheckDialog, setOpenNewCheckDialog] = useState(false);

  // const [refreshPage, setRefreshPage] = useState(false);
  const [currency, setCurrency] = useState({});
  // const [orders, setOrders] = useState([]);
  const [overview, setOverview] = useState({});
  const [breakdown, setBreakdown] = useState({});
  const [locationPoints, setLocationPoints] = useState([]);
  const [mapZoom, setMapZoom] = useState(6);
  // const [itemCount, setItemCount] = useState(0);
  // const [usedCount, setUsedCount] = useState(0);

  // let symbol = "";

  // const [openDispenseDialog, setOpenDispenseDialog] = useState(false);
  // const [order, setOrder] = useState(null);

  // const [openCopySnackBar, setOpenSnackBar] = useState(false);
  // async function copy(stringtext) {
  //   // console.log(stringtext);
  //   try {
  //     await navigator.clipboard.writeText(stringtext);
  //     setOpenSnackBar(true);
  //   } catch (err) {
  //     console.error("Failed to copy: ", err);
  //   }
  // }

  // const tableColumns = [
  //   { Header: "Order", accessor: "order", align: "left" },
  //   { Header: "Campaign", accessor: "campaign", align: "left" },
  //   { Header: "Amount", accessor: "amount", align: "left" },
  //   { Header: "Method", accessor: "payment_method", align: "left" },
  //   { Header: "Customer", accessor: "customer", align: "left" },
  //   { Header: "Agent", accessor: "agent", align: "left" },
  //   { Header: "Group", accessor: "agent_group", align: "left" },
  //   // { Header: "Aggregator", accessor: "aggregator", align: "left" },
  //   // { Header: "Country", accessor: "country", align: "left" },
  //   { Header: "State", accessor: "state", align: "left" },
  //   // { Header: "City", accessor: "city", align: "left" },
  //   { Header: "Tag", accessor: "tag", align: "left" },
  //   { Header: "Location", accessor: "location", align: "center" },
  //   { Header: "Added On", accessor: "created", align: "center" },
  // ];

  // const buildRateRows = (data) => {
  //   const rows = [];
  //   data.map((row) => {
  //     rows.push({
  //       campaign: row.campaign,
  //       customer: row.customer,
  //       amount: `${symbol}${(row.amount / 100).toLocaleString("en", {
  //         minimumFractionDigits: 2,
  //         maximumFractionDigits: 2,
  //       })}`,
  //       payment_method: row.payment_method,
  //       agent: row.agent,
  //       agent_group: row.agent_group,
  //       // aggregator: row.aggregator,
  //       // country: row.country ? row.country : "--",
  //       state: row.state ? row.state : "--",
  //       // city: row.city ? row.city : "--",
  //       tag: row.tag ? row.tag : "--",
  //       location: (
  //         <a
  //           rel="noreferrer"
  //           target="_blank"
  //           href={`https://maps.google.com?q=${row.latitude},${row.longitude}`}
  //         >
  //           <Icon>location_on</Icon>
  //         </a>
  //       ),
  //       order: (
  //         <MDBox mt={1} variant="button">
  //           <MDButton
  //             size="small"
  //             variant="contained"
  //             color="info"
  //             iconOnly
  //             circular
  //             onClick={() => {
  //               if (row.successful) {
  //                 setOrder(row);
  //                 setOpenDispenseDialog(false);
  //                 navigate(`/campaigns-orders/${row.reference}`);
  //               }
  //             }}
  //           >
  //             <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
  //               visibility
  //             </Icon>
  //           </MDButton>
  //         </MDBox>
  //       ),
  //       created: row.created,
  //     });
  //     return null;
  //   });

  //   return rows;
  // };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/dashboard.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCurrency(result.data.data.currency);
            setOverview(result.data.data.overview);
            setBreakdown(result.data.data.overview.breakdown);
            setLocationPoints(result.data.data.overview.locationPoints);
            // setUsedCount(result.data.data.used_count);
            // symbol = result.data.data.currency.symbol;
            // const rows = buildRateRows(result.data.data.orders);
            // setOrders(rows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      {/* <Dialog open={openUploadAgentsDialog}>
          <DialogTitle>
            <MDBox>Upload Agents</MDBox>
          </DialogTitle>
          <DialogContent>
            <MDBox mt={2} mb={3}>
              <MDBox mt={4}>
                <TextField
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  type="file"
                  name="upload_file"
                  id="upload_file"
                  // onChange={handleFileInputChange}
                  onChange={(e) => fileSelected(e)}
                />
              </MDBox>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenUploadAgentsDialog(false);
              }}
              color="dark"
              variant="outlined"
            >
              Cancel
            </MDButton>
            <MDButton
              color="primary"
              variant="outlined"
              onClick={() => {
                uploadAgents();
              }}
            >
              Upload Agents
            </MDButton>
          </DialogActions>
        </Dialog> */}
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={3}>
                    <MDBox align="center">
                      <Icon color="success" fontSize="large">
                        bar_chart
                      </Icon>
                    </MDBox>
                    <MDBox mt={1}>
                      <MDBox align="center">
                        <MDTypography variant="h6" fontWeight="medium" fontSize="32px">
                          {currency.symbol}
                          {((overview.salesVolume ? overview.salesVolume : 0) / 100).toLocaleString(
                            "en",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="light">
                          Total Volume
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                    <MDBox mt={3}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={4} lg={4}>
                          <MDBox
                            sx={{
                              textAlign: {
                                xs: "center",
                                md: "start",
                                lg: "start",
                              },
                            }}
                          >
                            <MDTypography variant="h6" fontWeight="medium">
                              {(overview.salesCount ? overview.salesCount : 0).toLocaleString(
                                "en",
                                {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }
                              )}
                            </MDTypography>
                            <MDTypography variant="h6" fontWeight="light">
                              Total Sales
                            </MDTypography>
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} md={4} lg={4}>
                          <MDBox align="center">
                            <MDTypography variant="h6" fontWeight="medium">
                              {currency.symbol}
                              {(
                                (overview.todayVolume ? overview.todayVolume : 0) / 100
                              ).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </MDTypography>
                            <MDTypography variant="h6" fontWeight="light">
                              Today&apos;s Volume
                            </MDTypography>
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} md={4} lg={4}>
                          <MDBox
                            sx={{
                              textAlign: {
                                xs: "center",
                                md: "end",
                                lg: "end",
                              },
                            }}
                          >
                            <MDTypography variant="h6" fontWeight="medium">
                              {(overview.todayCount ? overview.todayCount : 0).toLocaleString(
                                "en",
                                {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }
                              )}
                            </MDTypography>
                            <MDTypography variant="h6" fontWeight="light">
                              Today&apos;s Sales
                            </MDTypography>
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={12} md={3} lg={3}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={3} align="center">
                    <MDBox>
                      <Icon color="info" fontSize="large">
                        group
                      </Icon>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDTypography variant="h6" fontWeight="medium">
                        {(overview.customerCount ? overview.customerCount : 0).toLocaleString(
                          "en",
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }
                        )}
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="light">
                        Total
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={7}>
                      <MDTypography variant="h6" fontWeight="light">
                        Customers
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={12} md={3} lg={3}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={3} align="center">
                    <MDBox>
                      <Icon color="warning" fontSize="large">
                        support_agent
                      </Icon>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDTypography variant="h6" fontWeight="medium">
                        {(overview.agentCount ? overview.agentCount : 0).toLocaleString("en", {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })}{" "}
                        /{" "}
                        {(overview.activeAgentCount ? overview.activeAgentCount : 0).toLocaleString(
                          "en",
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }
                        )}
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="light">
                        Total / Active
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={7}>
                      <MDTypography variant="h6" fontWeight="light">
                        Agents
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      {breakdown !== null && (
        <MDBox pt={3} pb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <VerticalBarChart
                icon={{ color: "success", component: "leaderboard" }}
                title="Volume Trend"
                description="Daily Sales volume"
                chart={{
                  labels: breakdown.days,
                  datasets: [
                    {
                      label: "Date",
                      color: "success",
                      data: breakdown.sum,
                    },
                  ],
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <VerticalBarChart
                icon={{ color: "info", component: "trending_up" }}
                title="Sales Trend"
                description="Daily Sales Count"
                chart={{
                  labels: breakdown.days,
                  datasets: [
                    {
                      label: "Date",
                      color: "info",
                      data: breakdown.count,
                    },
                  ],
                }}
              />
            </Grid>
          </Grid>
        </MDBox>
      )}

      {locationPoints.length > 0 && (
        <MDBox mb={5} mt={3}>
          <Card>
            <MDBox p={3}>
              <MDBox mb={3} display="flex" justifyContent="space-between">
                <MDBox>
                  <MDTypography variant="h6" fontWeight="bold">
                    Location HeatMap
                  </MDTypography>
                </MDBox>
                <MDBox>
                  <MDButton
                    size="small"
                    variant="outlined"
                    color="dark"
                    iconOnly
                    onClick={() => {
                      let pZoom = mapZoom;
                      pZoom -= 1;
                      pZoom = pZoom < 4 ? 4 : pZoom;
                      setMapZoom(pZoom);
                    }}
                  >
                    <Icon>remove</Icon>
                  </MDButton>
                  &nbsp;
                  <MDTypography variant="caption" fontSize={10} fontWeight="light">
                    Zoom
                  </MDTypography>
                  &nbsp;
                  <MDButton
                    size="small"
                    variant="outlined"
                    color="dark"
                    iconOnly
                    onClick={() => {
                      let pZoom = mapZoom;
                      pZoom += 1;
                      pZoom = pZoom > 20 ? 20 : pZoom;
                      setMapZoom(pZoom);
                    }}
                  >
                    <Icon>add</Icon>
                  </MDButton>
                </MDBox>
              </MDBox>
              <MDBox sx={{ height: "65vh", width: "100%" }}>
                <GoogleMapReact
                  bootstrapURLKeys={{ key: AppConfig.google_map_key }}
                  defaultCenter={{
                    lat: 9.084576,
                    lng: 8.674252,
                  }}
                  defaultZoom={mapZoom}
                  zoom={mapZoom}
                >
                  {locationPoints.map((loc) => {
                    console.log(loc.lat);
                    return (
                      // <AnyReactComponent
                      //   cRef={loc.reference}
                      //   lat={loc.lat}
                      //   lng={loc.lng}
                      //   text="My Marker"
                      // />
                      <MDBox
                        lat={loc.lat}
                        lng={loc.lng}
                        onClick={() => navigate(`/campaigns-orders/${loc.reference}`)}
                      >
                        <MDTypography fontSize={24}>
                          <Icon color="error">location_on</Icon>
                        </MDTypography>
                      </MDBox>
                    );
                  })}
                </GoogleMapReact>
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
      )}

      {/* <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox
                        pt={2}
                        px={2}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <MDTypography variant="h6" fontWeight="medium">
                          Recent Sales
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={5}>
                        <DataTable
                          table={{ columns: tableColumns, rows: orders }}
                          isSorted
                          entriesPerPage
                          showTotalEntries
                          buttons
                          noEndBorder
                        />
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox> */}
      <Footer />
    </DashboardLayout>
  );
}

export default DashboardOverview;
